import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import '../__generated__/styles/dropdown.css';
import { uniqueId } from '@paypalcorp/pp-react-utils';

var styles = {"ppvx_dropdown__label":"ppvx_dropdown__label___3-6-4","ppvx_dropdown":"ppvx_dropdown___3-6-4","ppvx_dropdown__icon--left":"ppvx_dropdown__icon--left___3-6-4","ppvx_dropdown__icon--right":"ppvx_dropdown__icon--right___3-6-4","ppvx_dropdown__control":"ppvx_dropdown__control___3-6-4","ppvx_dropdown--nolabel":"ppvx_dropdown--nolabel___3-6-4","ppvx_field--error":"ppvx_field--error___3-6-4","ppvx_dropdown__control--icon-right":"ppvx_dropdown__control--icon-right___3-6-4","ppvx_dropdown__helper-text":"ppvx_dropdown__helper-text___3-6-4","ppvx_dropdown__error-text":"ppvx_dropdown__error-text___3-6-4"};

var _excluded = ["className", "errorText", "helperText", "id", "label", "value", "leftIcon", "rightIcon", "options", "onChange", "placeholder", "dir"],
    _excluded2 = ["label"];

var renderLabel = function (text, id) {
  return /*#__PURE__*/React.createElement("label", {
    className: styles.ppvx_dropdown__label,
    htmlFor: id
  }, text);
}; // Get either the error message or helper text or... nothing


var renderMessage = function (errorText, helperText, msgId) {
  return errorText && /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_dropdown__error-text'],
    id: msgId
  }, errorText) || helperText && /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_dropdown__helper-text'],
    id: msgId
  }, helperText) || null;
};

var renderIcon = function (icon, side) {
  return icon ? React.cloneElement(icon, {
    className: clsx(icon.className, styles["ppvx_dropdown__icon--".concat(side)])
  }) : null;
};

var Dropdown = function (_ref) {
  var _clsx;

  var className = _ref.className,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      id = _ref.id,
      label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      dir = _ref.dir,
      rest = _objectWithoutProperties(_ref, _excluded);

  var internalOptions = _toConsumableArray(options);

  var dropDownId = id !== null && id !== void 0 ? id : uniqueId('Dropdown_');
  var error = !!errorText;
  var msgId = "message_".concat(dropDownId);
  var hasOptions = options && options.length > 0;
  var containerClass = clsx(styles.ppvx_dropdown, className, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_field--error'], error), _defineProperty(_clsx, styles['ppvx_dropdown--nolabel'], !label), _clsx)); // Add in placeholder selection option

  if (placeholder !== undefined) {
    internalOptions = [{
      label: placeholder,
      disabled: true,
      hidden: true,
      value: ''
    }].concat(_toConsumableArray(internalOptions));
  }

  var valueProps = onChange ? {
    onChange: onChange,
    value: value
  } : {
    defaultValue: value
  };
  var inputTagClasses = clsx(styles.ppvx_dropdown__control, _defineProperty({}, styles['ppvx_dropdown__control--icon-right'], rightIcon));
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    dir: dir
  }, renderIcon(leftIcon, 'left'), /*#__PURE__*/React.createElement("select", _extends({
    id: dropDownId,
    className: inputTagClasses,
    "aria-invalid": error,
    "aria-describedby": errorText || helperText ? msgId : null // This is gonna blow at some point, let's get rid of it when it does and remove a dropdown variant
    // Brian Cox is going to do this work.
    // I assert that the 'required' attribute is not useful in a react environment
    // So I am commandeering it for my own purposes. If someone can show me a
    // valid use case, I will solve this issue a different way... --BCC
    ,
    required: placeholder === ''
  }, valueProps, rest), hasOptions && internalOptions.map(function (_ref2, index) {
    var optionLabel = _ref2.label,
        opts = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement("option", _extends({
      key: index
    }, opts), optionLabel);
  })), label && renderLabel(label, dropDownId), renderMessage(errorText, helperText, msgId), renderIcon(rightIcon, 'right'));
};

export { Dropdown };
